import React, {useState} from "react";


export const useMyKudoDialog = () => {
    const [isMyKudoDialogOpen, setMyKudoDialogOpen] = useState<boolean>(false);
    return {
        isMyKudoDialogOpen,
        setMyKudoDialogOpen,
    }
};